module.exports = __webpack_public_path__ + "img/box6-13.d7a5d0db.png";